import Vue from 'vue';
import App from './App.vue';
import router from './router';
import VueI18n from 'vue-i18n'; // ✅ เพิ่มตรงนี้

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'vue2-datepicker/index.css';
import './assets/custom.scss';
import 'sweetalert2/src/sweetalert2.scss';

import th from './lang/th';
import en from './lang/en';

Vue.config.productionTip = false;

Vue.use(VueI18n); // ✅ ใช้งาน vue-i18n

const i18n = new VueI18n({
  locale: 'th', // ค่าเริ่มต้นภาษา
  fallbackLocale: 'en',
  messages: {
    th,
    en
  }
});

new Vue({
  render: h => h(App),
  router,
  i18n // ✅ เพิ่ม i18n เข้ามาใน instance
}).$mount('#app');
